import React from 'react';
import { IClientLogoProps } from './types';
import styled from './ClientLogo.module.css';

const ClientLogo: React.FC<IClientLogoProps> = ({ imageUrl }) => {
  return <img className={styled.logo} src={imageUrl} alt="Client Logo" />;
};

export default ClientLogo;
